import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {TableFilterKey} from "../../model/filters/TableFiltersDefinitions";
import {TablePage} from "../../model/utils/TablePage";

interface InitialStateInterface {
    data: {
        [TableFilterKey.NOMENCLATURE_GUIDE_FILTER]: TablePage<any> | null,
        [TableFilterKey.USER_GUIDE_FILTER]: TablePage<any> | null,
        [TableFilterKey.PRODUCTION_ORDER_EXECUTION_JOURNAL_FILTER]: TablePage<any> | null,
        [TableFilterKey.INDIVIDUALS_GUIDE_FILTER]: TablePage<any> | null,

        [TableFilterKey.ADMINISTRATIVE_ROLE_GUIDE_FILTER]: TablePage<any> | null,
        [TableFilterKey.TECHNOLOGICAL_PROCESS_CHART_GUIDE_FILTER]: TablePage<any> | null,
        [TableFilterKey.PRODUCTION_STAGE_GUIDE_FILTER]: TablePage<any> | null,
        [TableFilterKey.TECHNOLOGICAL_OPERATION_GUIDE_FILTER]: TablePage<any> | null,
        [TableFilterKey.ADMINISTRATIVE_AND_FUNCTIONAL_ZONE_GUIDE_FILTER]: TablePage<any> | null,
        [TableFilterKey.PRODUCTION_ORDER_JOURNAL_FILTER]: TablePage<any> | null,
        [TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER]: TablePage<any> | null,
        [TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER]: TablePage<any> | null,
        [TableFilterKey.MEASUREMENT_UNIT_GUIDE_FILTER]: TablePage<any> | null,
        [TableFilterKey.MEASUREMENT_OKEI_GUIDE_FILTER]: TablePage<any> | null,
        [TableFilterKey.LOGS_FILTER]: TablePage<any> | null,
    }
}
const initialState: InitialStateInterface = {
    data: {
        [TableFilterKey.NOMENCLATURE_GUIDE_FILTER]: null,
        [TableFilterKey.USER_GUIDE_FILTER]: null,
        [TableFilterKey.PRODUCTION_ORDER_EXECUTION_JOURNAL_FILTER]: null,
        [TableFilterKey.INDIVIDUALS_GUIDE_FILTER]: null,

        [TableFilterKey.ADMINISTRATIVE_ROLE_GUIDE_FILTER]: null,
        [TableFilterKey.TECHNOLOGICAL_PROCESS_CHART_GUIDE_FILTER]: null,
        [TableFilterKey.PRODUCTION_STAGE_GUIDE_FILTER]: null,
        [TableFilterKey.TECHNOLOGICAL_OPERATION_GUIDE_FILTER]: null,
        [TableFilterKey.ADMINISTRATIVE_AND_FUNCTIONAL_ZONE_GUIDE_FILTER]: null,
        [TableFilterKey.PRODUCTION_ORDER_JOURNAL_FILTER]: null,
        [TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER]: null,
        [TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER]: null,
        [TableFilterKey.MEASUREMENT_UNIT_GUIDE_FILTER]: null,
        [TableFilterKey.MEASUREMENT_OKEI_GUIDE_FILTER]: null,
        [TableFilterKey.LOGS_FILTER]: null,
    }
}

interface AddData {
    key: TableFilterKey,
    data: TablePage<any>
}

export const dataSlice = createSlice({
    name: "data",
    initialState,
    reducers: {
        addData: (state, action: PayloadAction<AddData>) => {
            if (state.data[action.payload.key] !== null) {
                state.data[action.payload.key] = {...action.payload.data, rows: state.data[action.payload.key]!.rows.concat(action.payload.data.rows)}
            } else {
                state.data[action.payload.key] = action.payload.data
            }
        },
        clearData: (state, action: PayloadAction<TableFilterKey>) => {
            if (state.data[action.payload] !== null) {
                state.data[action.payload] = null
            }
        }
    }
})

export const dataReducer = dataSlice.reducer
export const dataActions = dataSlice.actions
export const {clearData} = dataSlice.actions